
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $5d4b34e4fe3dc4ec$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"2xn4F\",\"definition-popup-content.78b299d8.js\",\"cyGuT\",\"feedback-collector.fab7db45.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.cd519c3f.js\",\"c4B8Z\",\"ai-feedback-flags.137115f6.js\",\"ffEVr\",\"vendors~editor_icon.e0fbd6cd.js\",\"6wr18\",\"vendors~editor_icon.8d004ef7.js\",\"lb9xb\",\"smart-card.b5fd8b54.js\",\"fQH6R\",\"embedCard.4e4fe698.js\",\"koKgZ\",\"datasourceRenderFailedAnalyticsWrapper.bcb2ce11.js\",\"fPDs0\",\"Rovo.e24f6f93.svg\",\"EfTik\",\"hoverCard.cc67c640.js\",\"fjYIR\",\"component-lazy.08b1d601.js\",\"hogcU\",\"component-lazy.89af9f9b.js\",\"dTsOE\",\"modal.1f14079f.js\",\"kjZZD\",\"vendors~editor_icon-object.52136ea2.js\",\"ffEVr\",\"vendors~editor_icon.e0fbd6cd.js\",\"6wr18\",\"vendors~editor_icon.8d004ef7.js\",\"dYtBN\",\"page-live-doc.23a58848.js\",\"hv4mn\",\"modal.860760a9.js\",\"cM9rX\",\"RelatedLinksModal.0e797ba5.js\",\"7nW1A\",\"RelatedLinksModal.runtime.dfa1f3ee.js\",\"7nW1A\",\"RelatedLinksModal.runtime.dfa1f3ee.js\",\"iraZ1\",\"react-markdown.d0df5225.js\",\"6PtxN\",\"cs.4af6da41.js\",\"8RKtn\",\"da.00cc494f.js\",\"fCIoO\",\"de.feb55cf0.js\",\"1geBW\",\"es.2b9a509c.js\",\"5WU5D\",\"et.c12c2abb.js\",\"i1Uow\",\"fi.577f953a.js\",\"3ZuKT\",\"fr.6da7024a.js\",\"5nJlY\",\"hu.3d953190.js\",\"Uq5C2\",\"it.d747a7e7.js\",\"9TzAL\",\"ja.6cac578c.js\",\"oPAjm\",\"ko.e5176471.js\",\"3fvcK\",\"nb.cf4f3e33.js\",\"iMYDs\",\"nl.0646b6ed.js\",\"jPHqC\",\"pl.7e10aa61.js\",\"3saM6\",\"pt_BR.2e845e69.js\",\"4hCdo\",\"pt_PT.3585f16f.js\",\"78gs3\",\"ru.6f4b63fe.js\",\"2XhMA\",\"sk.9b031399.js\",\"f7Egw\",\"sv.567af81d.js\",\"aiZUj\",\"tr.5656666a.js\",\"6rH3p\",\"th.f0261be3.js\",\"lS1VG\",\"uk.fe1da325.js\",\"fFbe4\",\"vi.32dd8df9.js\",\"7JTjB\",\"zh_TW.3a48b1fe.js\",\"dMjyc\",\"zh.37507780.js\",\"cPSQq\",\"renderer.b33be1bd.js\",\"9wbwa\",\"calendar-dark.a0ed3c18.svg\",\"edV1v\",\"calendar-light.caa4677f.svg\",\"5P10P\",\"location-dark.395fc7dc.svg\",\"1jWRt\",\"location-light.9d9cfd0a.svg\"]"));


$parcel$global.rlb("iIoyG")
//# sourceMappingURL=definition-popup-content.runtime.21e49412.js.map
